import React from 'react';
import { SqGameBackEndModel } from 'types/SqGame.types';
import styles from './GameItem.module.scss';

type GameItemProps = {
  className?: string;
  onGameClicked: (gameId: string, gameTitle: string) => void;
  game: SqGameBackEndModel;
};

const GameItem: React.FC<GameItemProps> = ({ className = '', game, onGameClicked }) => {
  const baseCls = `${styles.GameItem} ${className}`;
  return (
    <div key={game.sqGameId} className={baseCls} onClick={() => onGameClicked(game.sqGameId, game.title)}>
      <span className={styles.GameItemTitle}>{game.title}</span>
      <div className={styles.GameItemTeams}>
        <img className={styles.GameItemTeam} src={game.homeTeam.logoUrl} alt="home team" />
        <img className={styles.GameItemTeam} src={game.awayTeam.logoUrl} alt="away team" />
      </div>
      <span className={styles.GameItemSpacer}> </span>
      <span className={styles.GameItemOpenSquares}>{game.openSquares}/100</span>
      <span className={styles.GameItemNumPlayers}>{game.playerIds.length}</span>
    </div>
  );
};

export default GameItem;
